import CardClient from '@atlaskit/link-provider/client';

import { type ProductDependenciesProviderResponse } from '../../index';
import type { ResolvedLinkDataObject } from './types';

/* function fetches metadata of given link via smart card client. Link is then assessed if it is an internal or external resource.
 * If external, the icon url string is returned. If not, undefined.
 * This function is used in Links Menu Extension to render custom icons for items in configuration panel.
 * This function may be used in future for LinkCards and Carousel Extensions
 */
export const getCustomIconUrl = async (
	link: string,
	submitError?: ProductDependenciesProviderResponse['submitError'],
): Promise<string | undefined> => {
	try {
		const client = new CardClient();
		const resolvedLinkData = ((await client.fetchData(link)) as ResolvedLinkDataObject).data || {};
		const isInternalResource = resolvedLinkData['atlassian:ari'];
		const externalIconUrl = resolvedLinkData.icon?.url;
		if (!isInternalResource && externalIconUrl) {
			return externalIconUrl;
		}
	} catch (error: any) {
		submitError?.(error);
	}
	return undefined;
};
